import React, { useEffect, useState } from 'react';
import { Phone, Mail, MapPin, Clock, ChevronRight, SendIcon } from 'lucide-react';
export function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="bg-cream" data-id="element-224">
      {/* Page Header */}
      <div className="bg-cream-dark border-b border-warmBorder" data-id="element-225">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-226">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-227">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-228">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-229" />
            <span className="text-charcoal font-medium" data-id="element-230">Contact Us</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-231">
            Contact Us
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-232">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16" data-id="element-233">
          {/* Main Content */}
          <div className="lg:w-2/3" data-id="element-234">
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-235">
              <p className="text-warmGray leading-relaxed text-lg mb-8" data-id="element-236">
                Thank you for your interest in our switchplates. You can either
                email us or call us. To email us just complete the information
                below and we'll get back to you as quickly as possible. If you
                prefer to call, our telephone information is shown at the bottom
                of every page. You can reach us Monday–Friday 9AM to 5PM EST.
              </p>

              {submitted ? <div className="text-center py-12" data-id="element-237">
                  <div className="w-16 h-16 bg-sage/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-238">
                    <Mail className="w-8 h-8 text-sage" data-id="element-239" />
                  </div>
                  <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-240">
                    Message Sent!
                  </h3>
                  <p className="text-warmGray text-lg max-w-md mx-auto" data-id="element-241">
                    Thank you for reaching out. We'll get back to you as quickly
                    as possible.
                  </p>
                </div> : <form onSubmit={e => {
              e.preventDefault();
              setSubmitted(true);
            }} className="space-y-5" data-id="element-242">
                  {/* Name */}
                  <div data-id="element-243">
                    <label htmlFor="name" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-244">
                      Name
                    </label>
                    <input type="text" id="name" required className="block w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="Your full name" data-id="element-245" />
                  </div>

                  {/* Address */}
                  <div data-id="element-246">
                    <label htmlFor="address" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-247">
                      Address
                    </label>
                    <input type="text" id="address" className="block w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="Street address" data-id="element-248" />
                  </div>

                  {/* City / State row */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-249">
                    <div data-id="element-250">
                      <label htmlFor="city" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-251">
                        City
                      </label>
                      <input type="text" id="city" className="block w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="City" data-id="element-252" />
                    </div>
                    <div data-id="element-253">
                      <label htmlFor="state" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-254">
                        State
                      </label>
                      <input type="text" id="state" className="block w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="State" data-id="element-255" />
                    </div>
                  </div>

                  {/* Country / Zip row */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-256">
                    <div data-id="element-257">
                      <label htmlFor="country" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-258">
                        Country
                      </label>
                      <select id="country" defaultValue="US" className="block w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all appearance-none" style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236B6560' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 16px center'
                  }} data-id="element-259">
                        <option value="US" data-id="element-260">United States of America</option>
                        <option value="CA" data-id="element-261">Canada</option>
                        <option value="other" data-id="element-262">Other</option>
                      </select>
                    </div>
                    <div data-id="element-263">
                      <label htmlFor="zip" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-264">
                        Zip Code
                      </label>
                      <input type="text" id="zip" className="block w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="Zip / Postal code" data-id="element-265" />
                    </div>
                  </div>

                  {/* Email */}
                  <div data-id="element-266">
                    <label htmlFor="email" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-267">
                      E-mail
                    </label>
                    <input type="email" id="email" required className="block w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="your@email.com" data-id="element-268" />
                  </div>

                  {/* Comments */}
                  <div data-id="element-269">
                    <label htmlFor="comments" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-270">
                      Comments
                    </label>
                    <textarea id="comments" rows={5} required className="block w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all resize-y" placeholder="How can we help you?" data-id="element-271" />
                  </div>

                  <button type="submit" className="inline-flex items-center gap-2 px-10 py-4 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors shadow-lg text-sm uppercase tracking-wider mt-2" data-id="element-272">
                    <SendIcon size={16} data-id="element-273" />
                    Submit
                  </button>
                </form>}
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:w-1/3" data-id="element-274">
            <div className="bg-white p-8 rounded-sm border border-warmBorder sticky top-32 shadow-warm" data-id="element-275">
              <h4 className="font-serif text-xl text-charcoal mb-6 border-b border-warmBorder pb-4" data-id="element-276">
                Get in Touch
              </h4>

              <div className="space-y-5 mb-8" data-id="element-277">
                <div className="flex items-start gap-3" data-id="element-278">
                  <Phone className="h-5 w-5 text-gold mt-0.5 flex-shrink-0" data-id="element-279" />
                  <div data-id="element-280">
                    <p className="text-sm text-warmGray mb-1 font-bold" data-id="element-281">
                      Phone
                    </p>
                    <a href="tel:8004976946" className="text-charcoal hover:text-gold transition-colors font-bold" data-id="element-282">
                      800.497.6946
                    </a>
                    <span className="text-warmGray mx-1.5" data-id="element-283">|</span>
                    <a href="tel:3046863170" className="text-warmGray hover:text-gold transition-colors" data-id="element-284">
                      304.686.3170
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3" data-id="element-285">
                  <Mail className="h-5 w-5 text-gold mt-0.5 flex-shrink-0" data-id="element-286" />
                  <div data-id="element-287">
                    <p className="text-sm text-warmGray mb-1 font-bold" data-id="element-288">
                      Email
                    </p>
                    <a href="mailto:switchplategallery@msn.com" className="text-charcoal hover:text-gold transition-colors text-sm" data-id="element-289">
                      switchplategallery@msn.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3" data-id="element-290">
                  <MapPin className="h-5 w-5 text-gold mt-0.5 flex-shrink-0" data-id="element-291" />
                  <div data-id="element-292">
                    <p className="text-sm text-warmGray mb-1 font-bold" data-id="element-293">
                      Address
                    </p>
                    <p className="text-charcoal text-sm leading-relaxed" data-id="element-294">
                      44 Grannys Lookout Loop
                      <br data-id="element-295" />
                      Cameron, WV 26033
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3" data-id="element-296">
                  <Clock className="h-5 w-5 text-gold mt-0.5 flex-shrink-0" data-id="element-297" />
                  <div data-id="element-298">
                    <p className="text-sm text-warmGray mb-1 font-bold" data-id="element-299">
                      Hours
                    </p>
                    <p className="text-charcoal text-sm" data-id="element-300">
                      Monday–Friday, 9AM–5PM EST
                    </p>
                  </div>
                </div>
              </div>

              <div className="pt-6 border-t border-warmBorder" data-id="element-301">
                <h4 className="font-serif text-xl text-charcoal mb-4" data-id="element-302">
                  Helpful Links
                </h4>
                <ul className="space-y-3" data-id="element-303">
                  <li data-id="element-304">
                    <a href="#/faq" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-305">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-306" />
                      FAQ &amp; "How To" Info
                    </a>
                  </li>
                  <li data-id="element-307">
                    <a href="#/size-chart" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-308">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-309" />
                      Size Chart
                    </a>
                  </li>
                  <li data-id="element-310">
                    <a href="#/about" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-311">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-312" />
                      About Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}